import {React, useEffect} from "react";

import { Helmet } from "react-helmet";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";

import Layout1 from "../img/selfecorche_layout.png";
import Topology from "../img/topology.jpg";
import HeadshotRef from "../img/headshot_ref.jpg";
import EcorcheFront1 from "../img/ecorche_front1.png";
import EcorcheFront2 from "../img/ecorche_front2.png";
import EcorcheQuarter1 from "../img/ecorche_quarter1.png";
import EcorcheQuarter2 from "../img/ecorche_quarter2.png";
import EcorcheCrop from "../img/ecorche_crop.png";




function SelfEcorche() {

  // useEffect(() => {
  //   document.title = "ETCHNG | Self-écorché: An anatomical self-portrait";  
  
  // }, []);  

  return (
    <>

<Helmet>
        <title>ETCHNG | Self-écorché: An anatomical self-portrait</title>
        <meta name="description" content="3D écorché self-portrait"/> 
        <meta name="keywords" content=" ETCHNG, medical illustrator, 3D, écorché, self-portrait, anatomy, self, portrait,"
        />
    </Helmet>

      <HeroHeader
        hero_img={Layout1}
        type="Animation —"
        name="Self-écorché: An anatomical self-portrait"
       
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>Dec 2017 </p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>3D artist</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>Blender, ZBrush</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
             This was a personal project to explore facial anatomy, with the additional challenge of the uncanny valley in trying to match my own likeness.
              </p>

            
            </div>

            
          </div>
    

            <div className="work">
              <div className="work__info">
                <h4>PROCESS</h4>

              </div>

            </div>
            <div className="work">

              <div className="work__info narrowColumn">

                <p>
I took reference photos of myself from the front and profile views, and made note of my most distinctive features (i.e. jawline, cheekbones, eyes, lips). These were used to inform the base mesh.                </p>


              </div>
              <div className="work__info wideColumn">
              <iframe className="youtube" height="515" src="https://www.youtube.com/embed/hV-b0wj8x5Y"
    title="YouTube video player" frameBorder="0"
    allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen></iframe>   
              </div>

            </div>




           
   <div className="work">
<div className="work__info wideColumn">
            	<img src={Topology} loading="lazy"
								alt="Skull of Homo erectus pekinensis with tissue depth markers"></img>
              </div>
              <div className="work__info narrowColumn">

                <p>
The reference images were also used to create a texture map for the skin.                </p>
                
                <img src={HeadshotRef} loading="lazy"
								alt="Skull of Homo erectus pekinensis with tissue depth markers"></img>

              </div>
              
           



            </div>


            <div className="work"> 
            <div className="work__info twoColumn"> 
            
            
            	<img src={EcorcheFront1} loading="lazy"
								alt="Front view of whole face"></img></div>
                            <div className="work__info twoColumn"> 

                <img src={EcorcheFront2} loading="lazy"
								alt="Frontal view - écorché view"></img>
            </div>
            </div>
            <div className="work">

              <div className="work__info narrowColumn">

                <p>
For fine detail, I added fuzz and stubble where relevant.                </p>
                


              </div>
              <div className="work__info wideColumn">
            	<img src={EcorcheCrop} loading="lazy"
								alt="Closeup of face"></img>
              </div>
           



            </div>
         

            
            <div className="work"> 
            <div className="work__info twoColumn"> 
            
            
            	<img src={EcorcheQuarter1} loading="lazy"
								alt="Skull of Homo erectus pekinensis with tissue depth markers"></img></div>
                            <div className="work__info twoColumn"> 

                <img src={EcorcheQuarter2} loading="lazy"
								alt="Skull of Homo erectus pekinensis with tissue depth markers"></img>
            </div>
            </div>


           

        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default SelfEcorche;
